module.exports = __webpack_public_path__ + "img/chuchai.e1ead100.png";